import * as React from "react";
import { styled } from "@mui/system";
import MUISnackbar, { SnackbarProps } from "@mui/material/Snackbar";

export const Snackbar = styled(
  (props: SnackbarProps) => <MUISnackbar {...props}></MUISnackbar>,
  {
    name: "Snackbar",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "&.MuiSnackbar-root.MuiSnackbar-anchorOriginTopRight ": {
    right: 32,
  },
  "&.MuiSnackbar-root .MuiSnackbarContent-root": {
    background: "transparent",
    boxShadow: "none",
  },
}));
